// ***** Dependencies *****
import { FC, useState } from "react";
// ***** Components *****
import InfoModal from "@components/modal/info-modal";

//***** Hooks *****
import { useTranslation } from "react-i18next";
// ***** Interfaces, Types and imports *****
import InfoTableContentI, { InfoTableButtonsI } from "@interfaces/tables/tables";
import { useWindowSize } from "react-use";
import ButtonDissabled from "@components/buttos/button-dissabled";

import Tooltip from '@material-ui/core/Tooltip';

interface IDetailedTable {
    title: string,
    content: InfoTableContentI[] | undefined,
    buttons: InfoTableButtonsI[] | undefined,
    goBack: () => void;
    deleteItem?: () => void
}

const DatailedTable: FC<IDetailedTable> = (props: IDetailedTable) => {
    const { title, buttons } = props;
    const { t } = useTranslation(["medicalHistory"]);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoContent, setInfoContent] = useState('');
    const { width } = useWindowSize();

    const getIcon = (documentType: string) => {
        const type = documentType.split('/');
        if (type[0] === 'application') {
            return type[1];
        }

        return type[0];
    };

    const buttonAction = (button: InfoTableButtonsI) => {
        if (button.action) {
            button.action();
        }
    }
    return (
       
        <div className="detailed-document width-available">
            <div className="detailed-document__header">
                <i className="far fa-arrow-left" onClick={() => props.goBack()}/>
                <p className="Title5 elipsis white-space-no-wrap">
                    {title}
                </p>
            </div>
            <div className="VerticalFlex__Gap-22">
                {props.content && props.content.length > 0 ?
                    props.content.map((eachContent, i) => {
                        if (eachContent.isGoal) {
                            return (
                                <div className="" key={i}>
                                    <p className="Overline1" onClick={() => { setInfoTitle(eachContent.extraInfo?.title ?? ''); setInfoContent(eachContent.extraInfo?.info ?? '') }}>
                                        {eachContent.label}
                                        {eachContent.extraInfo ?
                                            <InfoModal
                                                title={infoTitle}
                                                info={infoContent}
                                            />
                                            : null}
                                    </p>
                                    <div className="" style={eachContent.color ? { color: eachContent.color } : {}}>
                                        <p>{eachContent.value}</p>
                                        {eachContent.node ?
                                        <div className="">
                                            {eachContent.node}
                                        </div>
                                        : null}
                                    </div>
                                </div>
                            )
                        }
                        if (eachContent.isIcon) {
                            return (
                                <div className='' key={i}>
                                    <p className='Overline1'> {eachContent.label} </p>
                                    <p className=''>
                                        <i
                                            className={`fas fa-file-${getIcon(
                                                eachContent.iconName ?? ''
                                            )}`}
                                        /> {eachContent.value}
                                    </p>
                                </div>
                            )
                        }
                        if (eachContent.isNode) {
                            return (
                                <div className='' key={i}>
                                    <p className='Overline1'> {eachContent.label} </p>
                                    {eachContent.node}
                                </div>
                            )
                        } else {
                            return (
                                <div className="" key={i}>
                                    <p className="Overline1"> {eachContent.label}:</p>
                                    <p className=" elipsis" title={eachContent.value}> {eachContent.value} </p>
                                </div>
                            )
                        }
                    })
                    : null}


            </div>
            <div className="" style={ width <= 800 ? {display: "flex" } : {} } >
                {buttons && buttons.length > 0 ?
                    buttons.map((eachButton, i) => {
                        if (eachButton.outlined) {
                            return (
                                <ButtonDissabled key={i} action={() => buttonAction(eachButton)} label={eachButton.buttontext} />
                            )
                        }
                        else {
                            return (
                                <Tooltip title={eachButton.buttontext}>
                                    <button key={i} className='ButtonTertiary' onClick={() => buttonAction(eachButton)}>
                                        <i className="fas fa-download"/>
                                    </button>
                                </Tooltip>
                            )
                        }
                    })

                    : null}
                    {
                        props.deleteItem ?
                        <Tooltip title='Eliminar'>
                            <button className="ButtonTertiary" onClick={props.deleteItem}>
                                <i className={`fas fa-trash-alt`}/>  
                            </button>
                        </Tooltip>
                        :null                
                    }
            </div>
        </div>
        
    );

}

export default DatailedTable;